import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrDeviceFieldAggrResponse } from '@/api/routes/stat/types';

import { fetchStaticDeviceByDay } from '../actionCreators';

interface InitialState {
  sidesDevice: AggrDeviceFieldAggrResponse,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  sidesDevice: [],
  isLoading: false,
  error: '',
};

export const aggrStaticSidesDeviceSlice = createSlice({
  name: 'aggrStaticSidesDeviceSlice',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchStaticDeviceByDay.fulfilled.type]: (state, action: PayloadAction<AggrDeviceFieldAggrResponse>) => {
      state.isLoading = false;
      state.error = '';
      state.sidesDevice = action.payload;
    },
    [fetchStaticDeviceByDay.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchStaticDeviceByDay.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default aggrStaticSidesDeviceSlice.reducer;
